import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  areYouDealer: [],

  totalOptions: 0,
  totalCamera: 0,

  selectedNVR: [],
  selectedCamera: [],
  selectedCabling: [],
  selectedLabor: [],
  selectedPoE: [],
  selectedHardWare: [],
  selectedSpecial: [],
  finalData: [],
  customerData: [],
  templateOptionsData: [],
  apiDATA: null,
  selectedNumberOfDrops: null,
  totalCablesSelected: null,
  customData: [],
  customData2: [],
  // State for Calculation
  basePriceForNVR: [],
  totalCartDataYouSelected: [],
  comparisonData: {},
  selectedCameraQuantity: {},
  selectedDrops: {},
  optionHeading: {},
  optionDescription: {},
  optionDisplayText: {},
  optionDiscounts: {},
  quoteVersion: "",

  // Option-1 State

  option_1: [],
  option_2: [],
  option_3: [],
};

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    updateComparisonData: (state, action) => {
      state.comparisonData = {
        ...(state.comparisonData || {}),
        ...(action.payload || {}),
      };
    },

    setDrops: (state, action) => {
      state.selectedDrops = {
        ...(state.selectedDrops || {}),
        ...(action.payload || {}),
      };
    },

    // setOptionsObject: (state, action) => {
    //   const { payload } = action;
    //   return {
    //     ...state,
    //     optionHeading: {
    //       ...state.optionHeading, // Maintain existing option headings
    //       ...payload, // Set new option headings
    //     },
    //   };
    // },

    // Option Description
    // setOptionsDescriptionObject: (state, action) => {
    //   const { payload } = action;
    //   return {
    //     ...state,
    //     optionDescription: {
    //       ...state.optionDescription, // Maintain existing option headings
    //       ...payload, // Set new option headings
    //     },
    //   };
    // },

    setOptionHeading: (state, action) => {
      const { whichOption, text } = action.payload;
      return {
        ...state,
        optionHeading: {
          ...state.optionHeading,
          [whichOption]: text, // Update specific option heading
        },
      };
    },

    setOptionDescription: (state, action) => {
      const { whichOption, text } = action.payload;
      return {
        ...state,
        optionDescription: {
          ...state.optionDescription,
          [whichOption]: text, // Update specific option heading
        },
      };
    },

    setOptionDisplayText: (state, action) => {
      const { whichOption, text } = action.payload;
      return {
        ...state,
        optionDisplayText: {
          ...state.optionDisplayText,
          [whichOption]: text,
        },
      };
    },

    setOptionDiscount: (state, action) => {
      const { whichOption, discount } = action.payload;
      const numericDiscount = Number(discount || 0);
      return {
        ...state,
        optionDiscounts: {
          ...(state.optionDiscounts || {}),
          [whichOption]: Number.isFinite(numericDiscount) ? numericDiscount : 0,
        },
      };
    },

    deleteItemsByOption: (state, action) => {
      const { category, whichOption } = action.payload;

      // Check if the category exists in the state
      if (state[category]) {
        // Filter items based on the condition and create a new state object
        return {
          ...state,
          [category]: state[category].filter(
            (item) => item.num_options != whichOption
          ),
        };
      }

      // If the category doesn't exist, return the state as is
      return state;
    },

    AddItemsByOption: (state, action) => {
      const { category, items } = action.payload;
      // Ensure the category exists in the state
      if (state[category]) {
        // Append new items to the existing array of items
        return {
          ...state,
          [category]: [...state[category], ...items],
        };
      } else {
        // If the category doesn't exist, initialize it with the new items
        return {
          ...state,
          [category]: items,
        };
      }
    },

    // Option-1
    setOption_1: (state, action) => {
      state.option_1 = action.payload;
    },

    // Tempate Data Custom Data2
    setSelectedCustomData2: (state, action) => {
      state.customData2 = action.payload;
    },

    clearQuoteData: (state) => {
      state.totalOptions = 0;
      state.totalCamera = 0;
      state.totalNoOptions = undefined;
      state.whichOptionSelected = "1";
      state.selectedNVR = [];
      state.selectedCamera = [];
      state.selectedCabling = [];
      state.selectedLabor = [];
      state.selectedPoE = [];
      state.selectedHardWare = [];
      state.selectedSpecial = [];
      state.finalData = [];
      state.comparisonData = {};
      state.selectedCameraQuantity = {};
      state.selectedDrops = {};
      state.selectedNumberOfDrops = null;
      state.totalCablesSelected = null;
      state.optionHeading = {};
      state.optionDescription = {};
      state.optionDisplayText = {};
      state.optionDiscounts = {};
      state.quoteVersion = "";
    },

    replaceImportedCart: (state, action) => {
      const payload = action.payload || {};

      state.selectedCamera = payload.selectedCamera || [];
      state.selectedCabling = payload.selectedCabling || [];
      state.selectedLabor = payload.selectedLabor || [];
      state.selectedNVR = payload.selectedNVR || state.selectedNVR || [];
      state.selectedPoE = payload.selectedPoE || state.selectedPoE || [];
      state.selectedHardWare = payload.selectedHardWare || state.selectedHardWare || [];
      state.selectedSpecial = payload.selectedSpecial || state.selectedSpecial || [];
    },

    // State for Calculation Starts
    basePriceForNVRss: (state, action) => {
      state.basePriceForNVR = action.payload;
    },
    incrementBasePriceForNVR: (state) => {
      state.basePriceForNVR += 1;
    },
    decrementBasePriceForNVR: (state) => {
      state.basePriceForNVR -= 1;
    },
    // State for Calculation Ends

    // Are you Dealer
    dealerSelected: (state, action) => {
      state.areYouDealer = action.payload;
    },

    // Option select
    optionSelected: (state, action) => {
      state.whichOptionSelected = action.payload;
    },

    totalSelectedOptions: (state, action) => {
      state.totalNoOptions = action.payload;
    },

    setTotalCamera: (state, action) => {
      state.totalCamera = Number(action.payload || 0);
    },

    setQuoteVersion: (state, action) => {
      state.quoteVersion = action.payload || "";
    },

    setImportedQuoteState: (state, action) => {
      const payload = action.payload || {};

      if (payload.quoteVersion !== undefined) {
        state.quoteVersion = payload.quoteVersion || "";
      }

      if (payload.totalCamera !== undefined) {
        state.totalCamera = Number(payload.totalCamera || 0);
      }

      if (payload.selectedDrops !== undefined) {
        state.selectedDrops = payload.selectedDrops || {};
      }

      if (payload.selectedCameraQuantity !== undefined) {
        state.selectedCameraQuantity = payload.selectedCameraQuantity || {};
      }

      if (payload.comparisonData !== undefined) {
        state.comparisonData = payload.comparisonData || {};
      }

      if (payload.optionDiscounts !== undefined) {
        state.optionDiscounts = payload.optionDiscounts || {};
      }
    },

    // Increment and Deceremnt Camera and Options Starts

    IncrementCamera: (state) => {
      state.totalCamera += 1;
    },
    DecrementCamera: (state) => {
      state.totalCamera -= 1;
    },

    IncrementCameraByFive: (state) => {
      state.totalCamera += 5;
    },
    IncrementCameraByTen: (state) => {
      state.totalCamera += 10;
    },

    deleteCameraByTen: (state) => {
      state.totalCamera -= 10;
    },

    IncrementOptions: (state) => {
      state.totalOptions += 1;
    },
    DecrementOptions: (state) => {
      state.totalOptions -= 1;
    },

    // Increment and Deceremnt Camera and Options Ends
    ResetCounters: (state) => {
      state.totalOptions = state.initialOptions;
      state.totalCamera = state.initialCamera;
    },

    setSelectedNVR: (state, action) => {
      const { payload } = action;

      if (payload.type === "edit") {
        const index = state.selectedNVR.findIndex(
          (nvr) => nvr.uniqueID === payload.uniqueID
        );
        if (index !== -1) {
          state.selectedNVR[index] = payload;
        }
      } else {
        state.selectedNVR.push(payload);
      }
    },

    updateNVRQuantity2: (state, action) => {
      const newObj = action.payload;
      const index = state.selectedNVR.findIndex(
        (nvr) => nvr.uniqueID === newObj.uniqueID
      );

      if (index !== -1) {
        state.selectedNVR[index] = newObj;
      }
    },

    deleteNVR: (state, action) => {
      const { uniqueID } = action.payload;
      state.selectedNVR = state.selectedNVR.filter(
        (item) => item.uniqueID !== uniqueID
      );
    },

    setSelectedCamera: (state, action) => {
      const { payload } = action;

      const index = state.selectedCamera.findIndex(
        (camera) =>
          camera.uniqueID === payload.uniqueID &&
          camera.num_options === payload.num_options
      );

      if (index !== -1 && payload.type === "edit") {
        state.selectedCamera[index] = payload;
      } else {
        state.selectedCamera.push(payload);
      }
    },

    setSelectedCameraQuantity: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        selectedCameraQuantity: {
          ...state.selectedCameraQuantity,
          ...payload,
        },
      };
    },

    deleteCamera: (state, action) => {
      const { uniqueID, option } = action.payload;

      state.selectedCamera = state.selectedCamera.filter(
        (item) => !(item.uniqueID === uniqueID && item.num_options === option)
      );
    },

    deletePoe: (state, action) => {
      const { name, option, uniqueID } = action.payload;
      state.selectedPoE = state.selectedPoE.filter(
        (item) =>
          !(
            item.Port_Name === name &&
            item.num_options === option &&
            item.uniqueID === uniqueID
          )
      );
    },

    setSelectedCabling: (state, action) => {
      if (!Array.isArray(state.selectedCabling)) {
        state.selectedCabling = [];
      }

      state.selectedCabling.push(action.payload);
    },

    // Update Cables Starts
    updateCables2: (state, action) => {
      const newObj = action.payload;
      const index = state.selectedCabling.findIndex(
        (cable) => cable.id === newObj.id && cable.uniqueID === newObj.uniqueID
      );

      if (index !== -1) {
        state.selectedCabling[index] = newObj;
      } else {
        state.selectedCabling.push(newObj);
      }
    },
    // Update Cables Ends

    deleteCabling: (state, action) => {
      const { name, option, uniqueID } = action.payload;
      state.selectedCabling = state.selectedCabling.filter(
        (item) => !(item.id === name && item.uniqueID === uniqueID)
      );
    },

    upsertLinkedLaborItem: (state, action) => {
      if (!Array.isArray(state.selectedLabor)) {
        state.selectedLabor = [];
      }
      const payload = action.payload || {};
      const { linkedParentUniqueID, id, num_options } = payload;
      if (!linkedParentUniqueID || !id) return;
      state.selectedLabor = state.selectedLabor.filter(
        (item) =>
          !(item.autoAdded === true &&
            item.linkedParentUniqueID === linkedParentUniqueID &&
            item.id === id &&
            String(item.num_options || "") === String(num_options || ""))
      );
      const quantity = Number(payload.quantity || payload.Product_Quantity || 0);
      if (quantity > 0) {
        state.selectedLabor.push(payload);
      }
    },

    deleteLinkedLaborItems: (state, action) => {
      const { linkedParentUniqueID } = action.payload || {};
      if (!linkedParentUniqueID || !Array.isArray(state.selectedLabor)) return;
      state.selectedLabor = state.selectedLabor.filter(
        (item) => !(item.autoAdded === true && item.linkedParentUniqueID === linkedParentUniqueID)
      );
    },

    setSelectedLabor: (state, action) => {
      if (!Array.isArray(state.selectedLabor)) {
        state.selectedLabor = [];
      }
      state.selectedLabor.push(action.payload);
    },

    deleteLabor: (state, action) => {
      const { name, option, uniqueID } = action.payload;
      state.selectedLabor = state.selectedLabor.filter(
        (item) =>
          !(
            item.id === name &&
            item.num_options === option &&
            item.uniqueID === uniqueID
          )
      );
    },

    // Update Labour Starts
    updateLabour2: (state, action) => {
      const newObj = action.payload;
      // Find and update the NVR in the state based on the NVR_Name or some unique identifier.
      const index = state.selectedLabor.findIndex(
        (labor) => labor.id === newObj.id && labor.uniqueID === newObj.uniqueID
      );
      if (index !== -1) {
        state.selectedLabor[index] = newObj;
      }
    },
    // Update Labour Ends

    setSelectedSpecial: (state, action) => {
      state.selectedSpecial.push(action.payload);
    },

    deleteSpecial: (state, action) => {
      const { uniqueID } = action.payload;
      state.selectedSpecial = state.selectedSpecial.filter(
        (item) => item.uniqueID !== uniqueID
      );
    },

    // Update Special Page Items
    updateSpecial2: (state, action) => {
      const updatedProduct = action.payload;
      const index = state.selectedSpecial.findIndex(
        (item) => item.uniqueID === updatedProduct.uniqueID
      );
      if (index !== -1) {
        state.selectedSpecial[index] = updatedProduct;
      }
    },
    // Update Special Page Items Ends

    // Update Camera Starts
    updateCamera2: (state, action) => {
      const newObj = action.payload;
      const index = state.selectedCamera.findIndex(
        (camera) => camera.uniqueID === newObj.uniqueID
      );

      if (index !== -1) {
        state.selectedCamera[index] = newObj;
      }
    },

    // Update Camera Ends

    setSelectedPoE: (state, action) => {
      state.selectedPoE.push(action.payload);
    },
    // Update Switch Starts
    updateSwitch2: (state, action) => {
      const updatedItem = action.payload;
      const index = state.selectedPoE.findIndex(
        (item) => item.uniqueID === updatedItem.uniqueID
      );

      if (index !== -1) {
        // Create a new array with the updated item
        state.selectedPoE = state.selectedPoE.map((item, i) =>
          i === index ? { ...item, ...updatedItem } : item
        );
      }
    },

    // Update Switch Ends

    // Update hardware Starts
    setSelectedHardWare: (state, action) => {
      if (!Array.isArray(state.selectedHardWare)) {
        state.selectedHardWare = [];
      }
      state.selectedHardWare.push(action.payload);
    },

    deleteSelectedHardware: (state, action) => {
      const { HardwareName, option, uniqueID } = action.payload;
      state.selectedHardWare = state.selectedHardWare.filter(
        (item) =>
          !(
            item.Product_Name === HardwareName &&
            item.num_options === option &&
            item.uniqueID === uniqueID
          )
      );
    },

    updateHardware2: (state, action) => {
      const index = state.selectedHardWare.findIndex(
        (item) => item.uniqueID === action.payload.uniqueID
      );
      if (index !== -1) {
        state.selectedHardWare[index] = action.payload;
      }
    },

    // Update Hardware Ends
    setFinalData: (state, action) => {
      state.finalData = action.payload;
    },
    setCustomerData: (state, action) => {
      state.customerData = action.payload;
    },

    // Template and Options Data

    setTemplateOptionsData: (state, action) => {
      state.templateOptionsData = action.payload;
    },
    // API DATA
    setAPIDATA: (state, action) => {
      state.apiDATA = action.payload;
    },
    // Number of Drops
    setSelectedNumberOfDrops: (state, action) => {
      state.selectedNumberOfDrops = action.payload;
    },
    // Total Cables Selected
    setTotalCablesSelected: (state, action) => {
      const nextValue = action.payload;

      if (nextValue && typeof nextValue === "object" && !Array.isArray(nextValue)) {
        if (nextValue.totalCablesSelected !== undefined) {
          state.totalCablesSelected = nextValue.totalCablesSelected;
        }
        return;
      }

      state.totalCablesSelected = Number(nextValue || 0);
    },
    //Custom Data
    setCustomData: (state, action) => {
      state.customData = action.payload;
    },
  },
});

export const {
  updateComparisonData,
  setDrops,
  deleteItemsByOption,
  AddItemsByOption,
  basePriceForNVRss,
  incrementBasePriceForNVR,
  decrementBasePriceForNVR,
  setOptionsObject,
  setOptionHeading,
  setOptionDisplayText,
  setOptionDiscount,
  setOptionsDescriptionObject,
  setOptionDescription,

  dealerSelected,
  optionSelected,
  totalSelectedOptions,
  setTotalCamera,
  setImportedQuoteState,
  setQuoteVersion,
  IncrementCamera,
  DecrementCamera,

  IncrementCameraByFive,
  IncrementCameraByTen,

  deleteCameraByTen,

  IncrementOptions,
  DecrementOptions,

  setSelectedNVR,
  updateNVRQuantity,
  updateNVRQuantity2,

  setSelectedCamera,
  updateCamera2,
  setSelectedCameraQuantity,

  setSelectedCabling,
  updateCables2,
  setSelectedLabor,
  upsertLinkedLaborItem,
  deleteLinkedLaborItems,
  updateLabour2,

  setSelectedPoE,
  updateSwitch2,

  setSelectedHardWare,
  deleteSelectedHardware,
  updateHardware2,

  setSelectedSpecial,
  updateSpecial2,

  setCustomerData,
  setTemplateOptionsData,
  setAPIDATA,
  setFinalData,
  deleteCamera,
  deleteNVR,
  deleteCabling,
  deleteLabor,
  deleteSpecial,
  deletePoe,
  ResetCounters,
  setSelectedNumberOfDrops,
  setTotalCablesSelected,
  setCustomData,
  setSelectedCustomData2,
  replaceImportedCart,
  clearQuoteData,
  setOption_1,
} = counterSlice.actions;
export default counterSlice.reducer;
